/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";
import env from "./envConfig";
import { debugLog } from "./loggingConfig";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
console.log(`Setting redirect: ${window.location.origin}`);
export const msalConfig = {
    auth: {
        clientId: env.REACT_APP_AZURE_CLIENT_ID,
        authority: `${env.REACT_APP_AZURE_INSTANCE}/${env.REACT_APP_TENANT_ID}`,
        redirectUri: window.location.origin
    },
    cache: {
        // cacheLocation: "sessionStorage", // This configures where your cache will be stored
        cacheLocation: "localStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }		
                switch (level) {		
                    case LogLevel.Error:		
                        debugLog.error(message);		
                        return;		
                    case LogLevel.Info:		
                        debugLog.info(message);		
                        return;		
                    case LogLevel.Verbose:		
                        debugLog.info(message);		
                        return;		
                    case LogLevel.Warning:		
                        debugLog.warn(message);		
                        return;		
                    default:
                        debugLog.log(message);
                        return;
                }	
            }	
        }	
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ["user.read", "user.readbasic.all"]
};

export const apiRequest = {
    scopes: [`api://${env.REACT_APP_AZURE_CLIENT_ID}/mycai.read`],
}

export const hubRequest = {
    scopes: [`microsoft.signalRService`]
}

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: `${env.REACT_APP_MICROSOFT_GRAPH_BASE_URL}/me`,
    graphMeImgEndpoint:
        `${env.REACT_APP_MICROSOFT_GRAPH_BASE_URL}/me/photos/240x240/$value`,
    graphUsersEndpoint: `${env.REACT_APP_MICROSOFT_GRAPH_BASE_URL}/users`,
    graphGroupsEndpoint: `${env.REACT_APP_MICROSOFT_GRAPH_BASE_URL}/groups`,
};
